import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleDown, faAngleDoubleUp } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faAngleDoubleDown, faAngleDoubleUp);

const PercentageGain = ({ width = "inherit", negIsPositive = false, ...props }) => {
  const value = Number(props.value);
  let color;
  if (!value && value !== 0) {
    return null;
  }

  const renderValue = (valueColor) => (
    <p style={{ color: valueColor, fontWeight: 800, margin: 0 }} data-testid="percentageGainValue">
      {value.toFixed(1)}%
    </p>
  );
  if (value === 0) {
    return renderValue("#7f838e");
  }

  const getColor = () => {
    if (negIsPositive) {
      color = value > 0 ? "#ff0000" : "#008000";
    } else {
      color = value > 0 ? "#008000" : "#ff0000";
    }
    return color;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width
      }}
    >
      <FontAwesomeIcon
        style={{ color: getColor(), marginRight: 10 }}
        icon={value > 0 ? "angle-double-up" : "angle-double-down"}
        size="xs"
        transform={{ size: 20 }}
        fixedWidth
      />
      {renderValue(getColor())}
    </div>
  );
};

PercentageGain.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  negIsPositive: PropTypes.bool,
  arrowAngle: PropTypes.string
};

export default PercentageGain;
